import { createRoutine } from 'redux-saga-routines'
import {
  FETCH_OPTINS,
} from './types'

export const fetchOptins = createRoutine(FETCH_OPTINS)
